import { render, staticRenderFns } from "./navigation-overlay.vue?vue&type=template&id=51fe3f34&"
import script from "./navigation-overlay.vue?vue&type=script&lang=js&"
export * from "./navigation-overlay.vue?vue&type=script&lang=js&"
import style0 from "./navigation-overlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fe3f34')) {
      api.createRecord('51fe3f34', component.options)
    } else {
      api.reload('51fe3f34', component.options)
    }
    module.hot.accept("./navigation-overlay.vue?vue&type=template&id=51fe3f34&", function () {
      api.rerender('51fe3f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/navigation-overlay.vue"
export default component.exports